let config = {
    appName: "fooddiary",
    dbName: "fooddiary"
}

export default config;